(function () {
    'use strict';

    angular
        .module('app')
        .controller('rightsidebar', rightsidebar);

    rightsidebar.$inject = ['$location', 'sidebarservice'];

    function rightsidebar($location, sidebarservice) {
        /* jshint validthis:true */
        var vm = this;
        vm.sidebarservice = sidebarservice;
        activate();

        function activate() {
            //initial page load
        }
    }

})();
